import React,{useState,useEffect} from 'react';
import MultiListExceptionPopUp from '../atoms/MultiListExceptionPopUp';
function FromMoveExceptionList(props) {
  const [loading, setLoading] = useState(false);  // loader state here
  return (
    <div className="row form-fields">
        <div className="label col-6" > 
            <label>  </label> 
        </div>                   
        <div className="item col-6" > 
            <button onClick={()=> {props.setShowPopUp3(true);} } className="btn btn-primary mb-2">
                  &nbsp; Process &nbsp;<span className="bi bi-gear-fill"></span>
            </button>

            <MultiListExceptionPopUp
                title3={props.label3} 
                show3={props.showPopUp3} 
                showsetter3={props.setShowPopUp3} 
                exceptionData={props.exceptionData} 
                datasetter3={props.datasetter3} 
                setLoading={setLoading}   // pass loader setter
                 />
        </div>
    </div>
  )
}

export default FromMoveExceptionList